import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Flex } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var NavigationButtonsLayoutContainer = function NavigationButtonsLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Flex, props, children);
};
NavigationButtonsLayoutContainer.propTypes = {
  children: PropTypes.node
};
NavigationButtonsLayoutContainer.defaultProps = {
  children: null
};
export { NavigationButtonsLayoutContainer as default };